import Hero from "@/sections/Hero";
import VslSection from "@/sections/VslSection";
import QuizSection from "@/sections/QuizSection";
import OpportunitySection from "@/sections/OpportunitySection";
import ProofSection from "@/sections/ProofSection";
import VideoWinsSection from "@/sections/VideoWinsSection";
import FaqSection from "@/sections/FaqSection";
import BottomCta from "@/sections/BottomCta";
import Footer from "@/sections/Footer";
import ActivityNotifications from "@/components/7fcc/ActivityNotifications";

// The /ready funnel page — unchanged from its previous composition.
export default function ReadyPage() {
  return (
    <>
      {/* Funnel: hero → VSL → form → the opportunity → proof → FAQ */}
      <Hero />
      <VslSection />
      <QuizSection />
      <OpportunitySection />
      <ProofSection />
      <VideoWinsSection />
      <FaqSection />
      <BottomCta />
      <Footer />
      <ActivityNotifications />
    </>
  );
}